import React, { FC, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Providers } from 'src/components/Providers';
import { Routes } from 'src/utils/routes';
import { API_URL } from 'src/config';

import { MainPage } from 'src/pages/Main';
import { FencePage } from 'src/pages/Fence';
import { RoofPage } from 'src/pages/Roof';

import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

import { getData, getVariables, getCities } from 'src/api';
import mockPriceList from 'src/mock/mockPriceList.json';

export const App: FC = () => {
  const { dispatch } = useStoreon<IState, IEvents>('appStore');

  useEffect(() => {
    const updateData = async () => {
      const newPriceList = await getData();
      const priceList = API_URL ? (newPriceList || mockPriceList) : mockPriceList;

      if (process.env.NODE_ENV !== 'production') {
        console.log('fetch newPriceList', newPriceList)
      }

      dispatch('app/set-price-list', { priceList });

      const variables = await getVariables();
      if (variables) {
        dispatch('app/set-variables', { variables });
      }

      const cities = await getCities();
      dispatch('app/set-cities', { cities });
    };

    updateData();
  }, [dispatch]);

  return (
    <Providers>
      <Switch>
        <Route component={MainPage} path={Routes.index} exact />
        <Route component={FencePage} path={Routes.fence} />
        <Route component={RoofPage} path={Routes.roof} />
        <Redirect to={Routes.index} />
      </Switch>
    </Providers>
  );
};
